var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1989_399)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.16003 0.660001C2.58158 0.237924 3.15349 0.000526352 3.75003 1.19624e-06H12.75C12.8486 -0.000174824 12.9462 0.0190762 13.0373 0.0566538C13.1284 0.0942313 13.2113 0.149398 13.281 0.219001L19.281 6.219C19.3506 6.28878 19.4058 6.37159 19.4434 6.46271C19.481 6.55382 19.5002 6.65144 19.5 6.75V18.75C19.5 19.3467 19.263 19.919 18.841 20.341C18.4191 20.7629 17.8468 21 17.25 21H3.75003C3.15329 21 2.581 20.7629 2.15904 20.341C1.73708 19.919 1.50003 19.3467 1.50003 18.75V2.25C1.50003 1.653 1.73703 1.08 2.16003 0.660001ZM10.7805 5.1495L10.9365 5.3055C11.1105 5.4195 11.2605 5.5695 11.3745 5.7435L14.1555 8.5245C14.2867 8.65561 14.376 8.82268 14.4122 9.00456C14.4484 9.18644 14.4298 9.37496 14.3588 9.54629C14.2879 9.71762 14.1677 9.86405 14.0135 9.96706C13.8593 10.0701 13.678 10.125 13.4925 10.125H11.6175V15.5625C11.6175 15.9603 11.4595 16.3419 11.1782 16.6232C10.8969 16.9045 10.5154 17.0625 10.1175 17.0625C9.71971 17.0625 9.33817 16.9045 9.05687 16.6232C8.77557 16.3419 8.61753 15.9603 8.61753 15.5625V10.125H6.74253C6.55708 10.125 6.37579 10.0701 6.22159 9.96706C6.06739 9.86405 5.9472 9.71762 5.87623 9.54629C5.80526 9.37496 5.78669 9.18644 5.82288 9.00456C5.85907 8.82268 5.94838 8.65561 6.07953 8.5245L8.86053 5.745C8.97453 5.571 9.12453 5.421 9.29853 5.307L9.45453 5.151C9.54159 5.06392 9.64495 4.99484 9.75871 4.94771C9.87247 4.90058 9.9944 4.87633 10.1175 4.87633C10.2407 4.87633 10.3626 4.90058 10.4764 4.94771C10.5901 4.99484 10.6935 5.06242 10.7805 5.1495Z",
    fill: "#B0AFAF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1989_399"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/Upload.7d11b4d73fac08df08f2872ab2251271.svg";
export { ForwardRef as ReactComponent };